"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomTextInput_1 = require("../atoms/ATLAtomTextInput");
var Backdrop_1 = require("../components/Backdrop");
var DropdownMenu_1 = require("../components/DropdownMenu");
var react_native_1 = require("react-native");
var defaultProps = {
    complementary: false,
    darkMode: false,
    disabled: false,
    isLoading: false,
    required: false,
    showDropdownSearchBox: false,
    textInputBaseProps: {}
};
// ASSETS --------------------------------------------------------------------------------------------------------------
var dropdownArrow = require('../assets/arrow_down.png');
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.InputWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding:  ", "px\n\t          ", "px;\n"], ["\n\tpadding:  ", "px\n\t          ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingAtomic;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingInputMarginHorizontal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLDropdownSelector = function (_a) {
    var value = _a.value, onChange = _a.onChange, dropdownData = _a.dropdownData, errorText = _a.errorText, helpText = _a.helpText, leftIcon = _a.leftIcon, searchPlaceholderText = _a.searchPlaceholderText, title = _a.title, searchFunction = _a.searchFunction, complementary = _a.complementary, darkMode = _a.darkMode, disabled = _a.disabled, isLoading = _a.isLoading, required = _a.required, showDropdownSearchBox = _a.showDropdownSearchBox, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, textInputBaseProps = _a.textInputBaseProps;
    var theme = ThemeProvider_1.useTheme();
    var _b = react_1.useState(false), dropdownVisible = _b[0], setDropdownVisible = _b[1];
    var showDropdown = function () {
        if (!disabled) {
            setDropdownVisible(true);
        }
    };
    var hideDropdown = function () {
        setDropdownVisible(false);
    };
    var renderTextInput = function () { return (react_1.default.createElement(ATLAtomTextInput_1.ATLAtomTextInput, __assign({ value: value, onChange: onChange, onPressRightButton: showDropdown, title: title, errorText: errorText, helpText: helpText, rightButtonIcon: dropdownArrow, leftIcon: leftIcon, disabled: disabled, disabledText: true, required: required, hideClearButton: true, boxColor: complementary ? theme.ColorComplementary1 : theme.ColorHighContrast, errorColor: theme.ColorDanger, focusColor: theme.ColorInfo, labelColor: complementary ? theme.ColorComplementary1 : theme.ColorLowContrast, leftIconColor: theme.ColorBrand1Default }, textInputBaseProps))); };
    var renderDropdown = function () { return (react_1.default.createElement(DropdownMenu_1.DropdownMenu, { darkMode: darkMode, dropdownData: dropdownData, showDropdownSearchBox: showDropdownSearchBox || defaultProps.showDropdownSearchBox, dropdownTitle: title, onClose: hideDropdown, onSelectOption: onChange, searchFunction: searchFunction, isLoading: isLoading, placeholderText: searchPlaceholderText })); };
    // Returns complete ATLDropdownSelector
    return (react_1.default.createElement(exports.InputWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
        react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: showDropdown },
            react_1.default.createElement(react_native_1.View, null,
                renderTextInput(),
                react_1.default.createElement(Backdrop_1.Backdrop, { modalVisible: dropdownVisible, handleClose: hideDropdown }, renderDropdown())))));
};
exports.ATLDropdownSelector.defaultProps = defaultProps;
exports.ATLDropdownSelector.displayName = 'ATLDropdownSelector';
var templateObject_1;
